import React, { useState, useEffect, useRef } from 'react';
import { FaCheckCircle } from 'react-icons/fa';

const FormationsSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const slides = [
    {
      id: 1,
      image: '../assets/images/baaa_1.png',
      alt: 'Formation CINEF'
    },
    {
      id: 2,
      image: '../assets/images/DAD_1.png',
      alt: 'Étudiants en formation'
    },
    {
      id: 3,
      image: '../assets/images/Gok_1.png',
      alt: 'Travail collaboratif'
    },
    {
      id: 4,
      image: '../assets/images/Gui_2.png',
      alt: 'Formation professionnelle'
    },
    {
      id: 5,
      image: '../assets/images/King_1.png',
      alt: 'Atelier de formation'
    }
  ];

  const benefits = [
    'Plus de 100 formations professionnelles',
    'Formations certifiantes reconnues',
    'Accompagnement personnalisé',
    'Formateurs expérimentés et qualifiés'
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [slides.length]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .formations-section {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          
          padding: 100px 0;
          overflow: hidden;
          position: relative;
        }

        .formations-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
         
        }

        .formations-container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
        }

        /* Left Content */
        .content-left {
          opacity: 0;
          transform: translateX(-60px);
          transition: all 1s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .content-left.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .section-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, #198754 0%, #20c997 100%);
          color: white;
          padding: 8px 20px;
          border-radius: 50px;
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 0.5px;
          margin-bottom: 24px;
          box-shadow: 0 4px 15px rgba(25, 135, 84, 0.2);
        }

        .section-title {
          font-size: 48px;
          font-weight: 900;
          color: #1a1a1a;
          line-height: 1.2;
          margin-bottom: 24px;
          letter-spacing: -1px;
        }

        .section-title .highlight {
          background: linear-gradient(135deg, #198754 0%, #20c997 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .section-description {
          font-size: 17px;
          color: #4a5568;
          line-height: 1.8;
          margin-bottom: 32px;
        }

        .benefits-list {
          list-style: none;
          margin-bottom: 40px;
        }

        .benefit-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 0;
          font-size: 16px;
          color: #2d3748;
          opacity: 0;
          transform: translateX(-20px);
          transition: all 0.6s ease;
        }

        .content-left.visible .benefit-item:nth-child(1) {
          opacity: 1;
          transform: translateX(0);
          transition-delay: 0.3s;
        }

        .content-left.visible .benefit-item:nth-child(2) {
          opacity: 1;
          transform: translateX(0);
          transition-delay: 0.45s;
        }

        .content-left.visible .benefit-item:nth-child(3) {
          opacity: 1;
          transform: translateX(0);
          transition-delay: 0.6s;
        }

        .content-left.visible .benefit-item:nth-child(4) {
          opacity: 1;
          transform: translateX(0);
          transition-delay: 0.75s;
        }

        .benefit-icon {
          color: #198754;
          font-size: 20px;
          flex-shrink: 0;
        }

        .cta-button {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          color: white;
          padding: 18px 40px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          text-decoration: none;
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);
          position: relative;
          overflow: hidden;
        }

        .cta-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          transition: left 0.5s ease;
        }

        .cta-button:hover::before {
          left: 100%;
        }

        .cta-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 35px rgba(220, 53, 69, 0.4);
        }

        .cta-button:active {
          transform: translateY(0);
        }

        /* Right Content - Carousel */
        .content-right {
          opacity: 0;
          transform: translateX(60px);
          transition: all 1s cubic-bezier(0.34, 1.56, 0.64, 1);
          position: relative;
        }

        .content-right.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .carousel-wrapper {
          position: relative;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
          aspect-ratio: 4/3;
          background: #e2e8f0;
        }

        .carousel-container {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }

        .carousel-slide {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: opacity 0.8s ease-in-out;
        }

        .carousel-slide.active {
          opacity: 1;
        }

        .carousel-slide img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .carousel-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 24px;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 100%);
          color: white;
        }

        .carousel-controls {
          position: absolute;
          bottom: 24px;
          right: 24px;
          display: flex;
          gap: 12px;
          z-index: 10;
        }

        .carousel-button {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border: none;
          color: #1a1a1a;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 18px;
        }

        .carousel-button:hover {
          background: white;
          transform: scale(1.05);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }

        .carousel-indicators {
          position: absolute;
          bottom: 24px;
          left: 24px;
          display: flex;
          gap: 8px;
          z-index: 10;
        }

        .indicator {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.4);
          border: none;
          cursor: pointer;
          transition: all 0.3s ease;
          padding: 0;
        }

        .indicator.active {
          background: white;
          width: 32px;
          border-radius: 4px;
        }

        /* Decorative Elements */
        .decorative-circle {
          position: absolute;
          border-radius: 50%;
          background: linear-gradient(135deg, rgba(25, 135, 84, 0.1) 0%, rgba(32, 201, 151, 0.1) 100%);
          pointer-events: none;
        }

        .circle-1 {
          width: 300px;
          height: 300px;
          top: -100px;
          right: -50px;
          opacity: 0;
          transition: all 1s ease;
          transition-delay: 0.5s;
        }

        .content-right.visible .circle-1 {
          opacity: 1;
          transform: scale(1);
        }

        .circle-2 {
          width: 200px;
          height: 200px;
          bottom: -50px;
          left: -50px;
          opacity: 0;
          transition: all 1s ease;
          transition-delay: 0.7s;
        }

        .content-left.visible .circle-2 {
          opacity: 1;
          transform: scale(1);
        }

        @media (max-width: 968px) {
          .formations-section {
            padding: 80px 0;
          }

          .formations-container {
            grid-template-columns: 1fr;
            gap: 60px;
          }

          .section-title {
            font-size: 36px;
          }

          .content-left,
          .content-right {
            transform: translateY(40px);
          }

          .content-left.visible,
          .content-right.visible {
            transform: translateY(0);
          }
        }

        @media (max-width: 640px) {
          .formations-section {
            padding: 60px 0;
          }

          .formations-container {
            padding: 0 16px;
            gap: 40px;
          }

          .section-title {
            font-size: 32px;
          }

          .section-description {
            font-size: 16px;
          }

          .cta-button {
            width: 100%;
            justify-content: center;
            padding: 16px 32px;
          }

          .carousel-controls {
            bottom: 16px;
            right: 16px;
            gap: 8px;
          }

          .carousel-button {
            width: 40px;
            height: 40px;
          }

          .carousel-indicators {
            bottom: 16px;
            left: 16px;
          }
        }
      `}</style>

      <section className="formations-section" ref={sectionRef}>
        {/* Decorative Elements */}
        <div className={`decorative-circle circle-2 ${isVisible ? 'visible' : ''}`} />

        <div className="formations-container">
          {/* Left Content */}
          <div className={`content-left ${isVisible ? 'visible' : ''}`}>


            <h2 className="section-title">
              Découvrez les formations qui <span className="highlight">vous conviennent</span>
            </h2>

            <p className="section-description">
              Explorez plus de 100 formations professionnelles offertes dans les pays de l'espace OHADA.
              Nous vous accompagnons dans le développement de vos compétences. Découvrez toutes les
              informations dont vous avez besoin afin de choisir la formation qui vous convient :
              durée, coût, lieu...
            </p>

            <ul className="benefits-list">
              {benefits.map((benefit, index) => (
                <li key={index} className="benefit-item">
                  <FaCheckCircle className="benefit-icon" />
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>

            <button
              className="cta-button"
              onClick={() =>
                window.open('https://www.cinef-bj.com/formations/', '_blank')
              }
            >
              Tout afficher
            </button>

          </div>

          {/* Right Content - Carousel */}
          <div className={`content-right ${isVisible ? 'visible' : ''}`}>
            <div className="decorative-circle circle-1" />

            <div className="carousel-wrapper">
              <div className="carousel-container">
                {slides.map((slide, index) => (
                  <div
                    key={slide.id}
                    className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                  >
                    <img src={slide.image} alt={slide.alt} />
                  </div>
                ))}
              </div>

              <div className="carousel-indicators">
                {slides.map((_, index) => (
                  <button
                    key={index}
                    className={`indicator ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => setCurrentSlide(index)}
                    aria-label={`Aller à la diapositive ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FormationsSection;